'use client'

import Script from 'next/script'
import env from '@/lib/env'
import { useSearchParams } from 'next/navigation'
import { GoogleTagManager } from '@next/third-parties/google'

const pixel = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('consent', 'revoke');
fbq('init', '${env.FB_PIXEL_ID}');
fbq('track', 'PageView');
function handleConsent(hasConsent) {
fbq("consent", hasConsent ? "grant" : "revoke");
}
document.addEventListener("cookieyes_consent_update", (eventData) => {
const data = eventData.detail;
handleConsent(data.accepted && data.accepted.includes("advertisement"));
});
document.addEventListener("cookieyes_banner_load", (eventData) => {
const data = eventData.detail;
handleConsent(data.categories && data.categories.advertisement);
});`

export default function ScriptWrapper() {
  const query = useSearchParams()
  const trackingDisabled = query.get('tracking') === 'off'
  if (trackingDisabled) return null

  return (
    <>
      <GoogleTagManager
        gtmId={env.GTM_CONTAINER_ID}
        dataLayerName="dataLayer"
        dataLayer={{
          consent: 'default',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
          ad_storage: 'denied',
          analytics_storage: 'denied',
          functionality_storage: 'denied',
          personalization_storage: 'denied',
          security_storage: 'granted',
          wait_for_update: 2000,
          url_passthrough: true,
          ads_data_redaction: true,
        }}
      />
      <Script
        strategy="afterInteractive"
        src={`https://cdn-cookieyes.com/client_data/${env.COOKIEYES_ID}/script.js`}
      />
      <Script id="fb-pixel" strategy="afterInteractive">
        {pixel}
      </Script>
    </>
  )
}
